export const getSectionId = (section: string): string => {
    return section.replaceAll(" ", "");
}